<!-- Start Common Upload Component -->
<div class="ecb-common-upload">

  <!-- Label -->
  <label class="ecb-upload-label">
    {{ label }}
  </label>

  <!-- Start Upload Container -->
  <div class="ecb-upload-container">

    <!-- Start Upload Preview Area -->
    <div class="ecb-upload-preview-area">

      <!-- Loading Spinner -->
      <div class="ecb-upload-loading" *ngIf="isUploading">
        <div class="ecb-upload-spinner"></div>

        <span>{{ uploadMessage || 'Uploading...' }}</span>
      </div>

      <!-- Single File Mode -->
      <ng-container *ngIf="mode === 'single' && !isUploading">

        <!-- Image Preview -->
        <img *ngIf="uploadedFiles.length && isImage(uploadedFiles[0])" [src]="uploadedFiles[0].fileUrl"
          [alt]="uploadedFiles[0].fileName" class="ecb-upload-preview-img" />

        <!-- Non Image Preview -->
        <div class="ecb-upload-document-preview" *ngIf="uploadedFiles.length && !isImage(uploadedFiles[0])">
          <i class="bi" [ngClass]="isPdf(uploadedFiles[0])
              ? 'bi-file-earmark-pdf-fill'
              : 'bi-file-earmark-fill'"></i>

          <strong>
            {{ uploadedFiles[0].fileName }}
          </strong>

          <small>
            {{ formatFileSize(uploadedFiles[0].fileSize) }}
          </small>
        </div>

        <!-- Empty Placeholder -->
        <div class="ecb-upload-placeholder" *ngIf="!uploadedFiles.length">
          <i class="bi bi-image"></i>

          <span>No file uploaded</span>
        </div>

      </ng-container>

      <!-- Multiple File Mode -->
      <ng-container *ngIf="mode === 'multiple' && !isUploading">

        <!-- Empty Placeholder -->
        <div class="ecb-upload-placeholder" *ngIf="!uploadedFiles.length">
          <i class="bi bi-cloud-arrow-up"></i>

          <span>No files uploaded</span>
        </div>

        <!-- Multiple Files Grid -->
        <div class="ecb-upload-multiple-grid" *ngIf="uploadedFiles.length">

          <div class="ecb-upload-file-card" *ngFor="let file of uploadedFiles; let i = index">

            <!-- File Thumbnail -->
            <div class="ecb-upload-file-thumbnail" (click)="openFile(file)">

              <img *ngIf="isImage(file)" [src]="file.fileUrl" [alt]="file.fileName" />

              <i *ngIf="!isImage(file)" class="bi" [ngClass]="isPdf(file)
                  ? 'bi-file-earmark-pdf-fill'
                  : 'bi-file-earmark-fill'"></i>

            </div>

            <!-- File Information -->
            <div class="ecb-upload-file-info">

              <strong [title]="file.fileName">
                {{ file.fileName }}
              </strong>

              <small>
                {{ formatFileSize(file.fileSize) }}
              </small>

            </div>

            <!-- Remove File -->
            <button type="button" class="ecb-upload-remove-btn" [disabled]="disabled" (click)="removeFile(i)"
              title="Remove file">
              <i class="bi bi-x-lg"></i>
            </button>

          </div>

        </div>

      </ng-container>

    </div>
    <!-- End Upload Preview Area -->

    <!-- Start Upload Actions -->
    <div class="ecb-upload-actions">

      <input #commonFileInput type="file" hidden [accept]="accept" [multiple]="mode === 'multiple'"
        [disabled]="disabled || isUploading" (change)="onFilesSelected($event)" />

      <!-- Choose / Change Button -->
      <button type="button" class="ecb-upload-btn" [disabled]="disabled || isUploading"
        (click)="commonFileInput.click()">

        <i class="bi bi-cloud-arrow-up"></i>

        {{
        mode === 'multiple'
        ? 'Add Files'
        : uploadedFiles.length
        ? 'Change File'
        : 'Choose File'
        }}

      </button>

      <!-- View Button - Single -->
      <button *ngIf="mode === 'single' && uploadedFiles.length" type="button" class="ecb-upload-view-btn"
        [disabled]="isUploading" (click)="openFile(uploadedFiles[0])" title="View file">
        <i class="bi bi-eye"></i>
      </button>

      <!-- Remove Button - Single -->
      <button *ngIf="mode === 'single' && uploadedFiles.length" type="button" class="ecb-upload-delete-btn"
        [disabled]="disabled || isUploading" (click)="removeFile(0)" title="Remove file">
        <i class="bi bi-trash3"></i>
      </button>

      <!-- Upload Information -->
      <small class="ecb-upload-hint">
        {{ getAcceptedFileTypes() }}.
        Maximum {{ maxFileSizeMB }} MB per file.
      </small>

    </div>
    <!-- End Upload Actions -->

  </div>
  <!-- End Upload Container -->

  <!-- Upload Error -->
  <div class="ecb-upload-error" *ngIf="errorMessage">
    <i class="bi bi-exclamation-circle"></i>

    <span>{{ errorMessage }}</span>
  </div>

</div>
<!-- End Common Upload Component -->